export const SIEM_DASHBOARD = {
  TITLE: 'SIEM',
  SUBTITLE: 'Gestión de información y eventos de seguridad',
  TABS: {
    OVERVIEW: 'Resumen',
    LOG_EXPLORER: 'Explorador de Logs',
    ALERTS: 'Alertas',
  },
  CUSTOM_RANGE: {
    TITLE: 'Rango personalizado',
    FROM: 'Desde',
    TO: 'Hasta',
    APPLY: 'Aplicar',
  },
  EVENTS: 'eventos',
  AGENT: 'agente',
  AGENTS: 'agentes',
  MORE: 'más',
  RAW_DASHBOARDS: {
    LABEL: 'Paneles sin procesar',
    SECURITY: 'Seguridad',
    STATISTICS: 'Estadísticas',
    AGENTS: 'Agentes',
    DOWNLOAD_AGENT: 'Descargar agente',
  },
  PRIORITIES: {
    LOW: 'Baja',
    MEDIUM: 'Media',
    HIGH: 'Alta',
    CRITICAL: 'Crítica',
  },
  CONNECTIONS: {
    TITLE: 'Conexiones',
    DESCRIPTION: 'Fuera de horario laboral',
    EMPTY: 'Sin conexiones fuera de horario laboral',
    COLUMNS: {
      TIMESTAMP: 'Marca de tiempo',
      AGENT: 'Agente',
      USER: 'Usuario',
      SOURCE: 'Origen',
      LOCATION: 'Ubicación',
      DIRECTION: 'Dirección',
    },
  },
  TIMELINE: {
    TITLE: 'Línea de tiempo',
    EVENTS: 'Eventos',
    ALERTS: 'Alertas',
    TOTAL: 'Total',
  },
  AUTH_EVENTS: {
    TITLE: 'Autenticación',
    FAILED_LOGINS: 'Inicios de sesión fallidos',
    BRUTE_FORCE: 'Fuerza bruta',
    USER_LOCKOUTS: 'Bloqueos de usuario',
    SUCCESSFUL_LOGINS: 'Inicios de sesión exitosos',
    NO_HOST_ACTIVITY: 'Sin actividad de host',
  },
  ALERTS: {
    TITLE: 'Alertas recientes',
    EMPTY: 'No hay alertas en el rango',
    TOOLTIP: 'Mostrando las últimas 10 alertas generadas por eventos de severidad Alta (12-14) o Crítica (15)',
    VIEW_ALL: 'Ver todas',
  },
  LOG_EXPLORER: {
    SEARCH_PLACEHOLDER: 'Buscar regla o agente',
    EMPTY: 'No hay logs en el rango',
    COLUMNS: {
      TIMESTAMP: 'Marca de tiempo',
      SEVERITY: 'Severidad',
      AGENT: 'Agente',
      DESCRIPTION: 'Descripción',
      OCCURRENCES: 'Cantidad',
    },
    FILTERS: {
      FILTER_BY_SEVERITY: 'Filtrar por severidad',
      FILTER_BY_AGENT: 'Filtrar por agente',
    },
    DRAWER: {
      LATEST_HIT: 'Último evento',
      OCCURRENCES: 'Ocurrencias',
      HITS: 'Últimos eventos',
      HIT: 'Evento',
      RAW_LOG: 'Log original',
      EMPTY: 'No se encontraron eventos para esta regla.',
      ERROR: 'Error al cargar los eventos.',
      DOWNLOAD: 'Exportar',
      DOWNLOAD_JSON: 'Exportar como JSON',
      DOWNLOAD_CSV: 'Exportar como CSV',
      CASE: {
        CREATE: 'Crear caso',
        TITLE: 'Crear caso',
        FIELD_DESCRIPTION: 'Descripción',
        FIELD_MITRE: 'Táctica MITRE',
        MITRE_NONE: 'Ninguna',
        SUBMIT: 'Crear',
        CANCEL: 'Cancelar',
        SUCCESS: 'Caso creado con éxito',
        ERROR: 'No se pudo crear el caso',
      },
      STATUS: {
        TITLE: 'Estado',
        OPEN: 'Abiertas',
        CLOSED: 'Cerradas',
        CLOSED_BADGE: 'Cerrada',
      },
      CLOSURE: {
        SECTION: 'Cierre',
        CLOSE: 'Cerrar alerta',
        REOPEN: 'Reabrir alerta',
        TITLE: 'Cerrar alerta',
        REASON_LABEL: 'Motivo de cierre',
        NOTES_LABEL: 'Notas adicionales',
        AFFECTED_DATA_LABEL: '¿Hay datos afectados?',
        AFFECTED_DATA_YES: 'Sí',
        AFFECTED_DATA_NO: 'No',
        CONFIRM: 'Cerrar alerta',
        CANCEL: 'Cancelar',
        CLOSE_SUCCESS: 'Alerta cerrada con éxito',
        REOPEN_SUCCESS: 'Alerta reabierta con éxito',
        ERROR: 'No se pudo actualizar la alerta',
      },
    },
  },
}

export const EDR_SIEM = {
  TITLE: 'EDR y SIEM',
  DASHBOARD: {
    TITLE: 'Panel',
    DESCRIPTION:
      'Vista centralizada de los datos de monitoreo, mostrando alertas, ' +
      'tendencias de amenazas y actividad en tiempo real a través de todos los agentes desplegados.',
    URLS: {
      SECURITY: 'Panel de eventos de seguridad',
      STATISTICS: 'Panel de estadísticas de eventos',
      AGENTS: 'Panel de agentes',
    },
  },
  AGENT: {
    TITLE: 'Agente',
    DESCRIPTION:
      'Acceso rápido para descargar y desplegar agentes en tus dispositivos, ' +
      'asegurando una cobertura integral para el monitoreo.',
    DOWNLOAD: {
      LINUX: 'Descargar Agente de Monitoreo Qalea',
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentación',
    DESCRIPTION:
      'Guías para configurar y gestionar el despliegue de agentes, así como para ' +
      'entender la cobertura de monitoreo en detalle.',
    URLS: {
      DEVICE: 'Instalando el agente en tu dispositivo',
      AWS: 'Instalando el agente en instancias AWS',
      EKS: 'Instalando el agente en un clúster EKS',
      MONITORING: 'Detalle de cobertura de monitoreo',
    },
  },
  RELEVANT_TRENDS: {
    TITLE: 'Eventos Relevantes',
    DESCRIPTION:
      'Explora aquí los eventos y patrones más relevantes en las alertas recientes ' +
      'para identificar amenazas recurrentes, monitorear riesgos emergentes y obtener ' +
      'información sobre tu postura de seguridad. Esta visión general ayuda a priorizar ' +
      'áreas que requieren atención inmediata y guía acciones proactivas para fortalecer ' +
      'las defensas.',
    TRENDS_NOT_YET_AVAILABLE:
      'El análisis de eventos estará disponible una vez que se haya ' +
      'recopilado suficiente información de alertas. Por favor, vuelve más tarde para revisar ' +
      'los patrones e insights críticos a medida que se desarrollen.',
  },
}
